export const environment = {
  production: false,
  apiUrl: (window as any).nplexEnv?.['NPLEX_ANSWERS_API_REMOTE_URL'] || 'http://localhost:8080'
};